import MyButton from "components/MyButton";
import React from "react";

interface LoadingScreenProps {
    onLoadingComplete: () => void;
}

function LoadingScreen({ onLoadingComplete }: LoadingScreenProps) {
    const handleStartClick = () => {
        onLoadingComplete();
    };

    return (
        <div className="landing-page">
            <h1 className="blink-me">Track Your Emotion Everyday</h1>
            <MyButton text="Start" type="positive" onClick={handleStartClick} />
        </div>
    );
}

export default LoadingScreen;
